import * as THREE from "three";
import Experience from "../Experience.js";

export default class Arcade {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("Arcade");
    }

    // Resource
    this.resource = this.resources.items.arcadeModel;

    this.setModel();
  }

  setModel() {
    this.model = this.resource.scene;
    this.model.position.set(-1.8, -.10, 2.4);
    this.model.rotateY(Math.PI * 0.70);

    this.model.name = "arcade";

    this.scene.add(this.model);

    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.name = this.model.name;
      }
    });
  }
}
